var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 14.0001C5.32718 14.0001 3.48311 13.2362 2.12348 11.8766C0.763837 10.517 0 8.6729 0 6.75008C0 3.81258 1.6875 1.17883 4.30031 0.0416403C4.3924 0.00150744 4.49444 -0.00995895 4.59313 0.00873541C4.69183 0.0274298 4.7826 0.0754179 4.85363 0.146447C4.92466 0.217476 4.97265 0.308252 4.99134 0.406947C5.01004 0.505643 4.99857 0.607681 4.95844 0.699765C4.65844 1.38852 4.5 2.2707 4.5 3.25008C4.5 6.69633 7.30375 9.50008 10.75 9.50008C11.7294 9.50008 12.6116 9.34164 13.3003 9.04164C13.3924 9.00151 13.4944 8.99004 13.5931 9.00873C13.6918 9.02743 13.7826 9.07542 13.8536 9.14645C13.9247 9.21748 13.9726 9.30825 13.9913 9.40695C14.01 9.50564 13.9986 9.60768 13.9584 9.69977C12.8213 12.3126 10.1875 14.0001 7.25 14.0001Z",
    fill: "#00FFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonIcon);
export default __webpack_public_path__ + "static/media/moonIcon.018e928200dab96176fa8ddd5ad92b5d.svg";
export { ForwardRef as ReactComponent };